<template>
  <div>
    <Head title="Crear Familia" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/settings/products/families">Familias</Link>
      <span class="text-sky-400 font-medium">/</span> Crear
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8 mb-10  ">
          <text-input v-model="form.descripcion" :error="form.errors.descripcion" class="pb-8 pr-6 w-full lg:w-2/3" label="Descripción" />
        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear Familia</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton.vue'
import Multiselect from '@vueform/multiselect'
import TextInputUpper from '@/Shared/TextInputUpper'
import SelectInput from '@/Shared/SelectInput'
  
export default {
  components: {
    Head,
    Link,
    SelectInput,
    LoadingButton,
    TextInput,
    Multiselect,
    TextInputUpper
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        descripcion: ''
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/products/families')
      //console.log(this.form)
    },
  },
}
</script>